.menu {
  z-index: var(--z-dropdown);
  width: max-content;
  min-width: 155px;
  max-width: 255px;
  max-height: 90vh;
  padding: 0.75rem 0;
  overflow: hidden;
  overflow: auto;
  background: var(--dropdown-background);
  border-radius: 0.5rem;
  box-shadow: var(--dropdown-shadow);
}

.base {
  display: block;
  width: 100%;
  padding: 0.25rem 0.75rem;
  font-size: var(--font-size-body-2);
  font-weight: var(--font-weight-light);
  color: inherit;
  text-align: left;
  text-decoration: none;
  background: none;
  border: none;
}

.item {
  display: flex;
  gap: 0.5rem;
  align-items: center;

  svg {
    width: 16px;
    height: 16px;
  }

  &:hover {
    color: var(--on-background);
    text-decoration: none;
    cursor: pointer;
    outline: none;
    background: var(--dropdown-item-background-hover);
  }

  &[aria-disabled="true"] {
    pointer-events: none;
    opacity: 0.5;
  }
}

.heading {
  font-weight: var(--font-weight-regular);
}

.trigger {
  outline: inherit;
}

.arrow {
  fill: var(--dropdown-background);
}

.endIcon {
  margin-left: auto;
}

.separator {
  margin: 0.25rem 0;
  border-top: 1px solid var(--dropdown-separator);
}
